/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { mjRegisterSimpleJQueryPlugin, mj_cloned_object } from './util.js';
import { showErrorToast } from './snackbar.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';


/**
 * Manja File Upload Widget ( .mjUploadWidget )
 *
 * methods:
 *  - init(opts)
 *  - destroy()
 *
 * usage:
 *  $('#container').mjUploadWidget( { type:'single', upload_url:.., post_params:.., file_types:'*.jpg;*.png', start:cb, progress:cb, success:cb, complete:cb } )
 *
 *  - or use post_params_cb instead of (or additionally to) post_params, post_params_cb is a function returning an array of objects with name & value properties,
 *    the advantage is that it is executed short before actual upload (and not at widget initialization time...)
 */
(function($,mj) {

	var _mj_fuw_id_counter = 0;

	var _mj_browser_support_inited = false,
		_m_using_multipart_form_data = true,
		_m_use_iframe_transport = false,
		_m_auto_form_submit_denied = false,
		_m_safari_workarounds = false;

	function _mj_init_browser_support() {
		if( !_mj_browser_support_inited ) {
			_m_use_iframe_transport = !( (!_m_using_multipart_form_data && $.support.xhrFileUpload) || $.support.xhrFormDataFileUpload );
			_m_auto_form_submit_denied = _m_use_iframe_transport && $.browser.msie;
			_m_safari_workarounds = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
			_mj_browser_support_inited = true;
		}
	}

	function _mj_fuw_id() {
		_mj_fuw_id_counter++;
		return 'mj_fuw_'+_mj_fuw_id_counter;
	}

	function _mj_post_params_to_object( pp ) {
		if( $.type(pp)==='function' ) pp = pp();
		if( Array.isArray(pp) ) {
			// array -> object
			var r = {};
			for( var i=0; i<pp.length; ++i ) r[pp[i].name] = pp[i].value;
			return r;
		}
		if( $.type(pp)==='object' ) {
			// object: accepted
			return mj_cloned_object(pp);
		}
		return {};
	}

	function _mj_post_params_to_array( pp ) {
		if( $.type(pp)==='function' ) pp = pp();
		if( Array.isArray(pp) ) {
			// array: accepted
			return pp;
		}
		if( $.type(pp)==='object' ) {
			// object -> array
			var r = [];
			$.each( pp, function(n,v) {
				r.push({name:n,value:v});
			} );
			return r;
		}
		return [];
	}

	function _mj_init2html( target_elem, opts, multiple ) {
		var self = $(target_elem),
			post_params = _mj_post_params_to_object(opts.post_params),
			file_param_name = 'Filedata',
			fu_wdg = self.html(  '<label for="'+opts.id+'-file">'+mjt('mu-label1')+'</label>'
								+'<input id="'+opts.id+'-file" type="file" name="'+file_param_name+'"'+(multiple?' multiple':'')+' />')
				.children('input');
		var i;

		// handle accepted file types...
		var _mj_file_allowed = function( file ) {
			return true;
		};
		var file_type_exts = [];
		if( opts.file_types && opts.file_types!='*.*' ) {
			var t = opts.file_types.split(';');
			for( i=0; i<t.length; ++i ) {
				if( t[i].substr(0,2)=='*.' ) file_type_exts.push(t[i].substr(2).toLowerCase());
			}
			var accept_attr = [];
			for( i=0; i<file_type_exts.length; ++i ) accept_attr.push('.'+file_type_exts[i]);
			fu_wdg.attr('accept',accept_attr.join(',')); // not yet supported at most browsers
			_mj_file_allowed = function( file ) {
				var n = file.name.lastIndexOf('.');
				if( n<0 ) return false; // never allowed
				var sfx = file.name.substr(n+1).toLowerCase();
				for( var i=0; i<file_type_exts.length; ++i ) {
					if( sfx==file_type_exts[i] ) return true;
				}
				return false;
			};
		}

		var use_styled_trigger = true;
		if( _m_auto_form_submit_denied ) {
			// use the direct file input (IE8 restriction: can not trigger file-input ...)
			use_styled_trigger = false;
		}
		var fu_btn = null;
		if( use_styled_trigger ) {
			self.children('label,input').hide();
			fu_btn = $('<button class="small muw-button" type="button"><span class="icon"></span><span class="muw-text" style="text-align:left">'+opts.button_text+'</span></button>')
				.css({'width':opts.button_width+'px','height':opts.button_height+'px'})
				.click( function() {
					const $btn = $(this);
					if( opts.before_start ) {
						opts.before_start( opts, function() {
							// simulate click on file input to show file browse dialog..
							$btn.parent().find('input').click();
						} );
					} else {
						// simulate click on file input to show file browse dialog..
						$btn.parent().find('input').click();
					}
					return false;
				} )
				.appendTo(self);
		}
		if( _m_safari_workarounds ) {
			fu_wdg
				.removeAttr('multiple')												// would report fileSize=0 for multiple file selection
				.css({'visibility':'hidden','width':'1px','height':'1px'})			// input must not be hidden
				.show();
		}
		var _upload_abort_fn = function() {
		};
		var fu_cancel = $('<button class="muw-cancel cancel-link" type="button">'+mjt('mu-cancel-upload')+'</button>')
			.hide()
			.click( function() {
				$(this).hide();
				_upload_abort_fn();
				return false;
			} )
			.appendTo(self);

		// queue state...
		var _mj_nfiles = 0,
			_mj_nfiles_fail = 0,
			_mj_nfiles_done = 0,
			_queue_start = function( data, nfiles ) {
				_mj_nfiles = nfiles;
				_mj_nfiles_fail = 0;
				_mj_nfiles_done = 0;
				if( opts.hasOwnProperty('queue_start') ) opts.queue_start(_mj_nfiles);
				if( fu_btn ) fu_btn.hide();
				if( fu_cancel ) fu_cancel.show();
			},
			_queue_completed_one = function( data, success ) {
				if( !success ) _mj_nfiles_fail ++;
				if( ++_mj_nfiles_done >= _mj_nfiles ) {
					if( opts.hasOwnProperty('queue_complete') ) opts.queue_complete(_mj_nfiles,_mj_nfiles_fail);
					if( fu_btn ) fu_btn.show();
					if( fu_cancel ) fu_cancel.hide();
					// reset counts for next upload ...
					_mj_nfiles = 0;
					_mj_nfiles_done = 0;
				}
			};
		fu_wdg.fileupload( {
			type: 'POST',
			dataType: 'json',
			formData: function( form ) {
				var tmp = opts.hasOwnProperty('post_params_cb') && opts.post_params_cb ? opts.post_params_cb(opts) : false;
				if( tmp!==false ) {
					if( Object.size(post_params)>0 ) {
						// merge post_params with tmp ...
						var r0 = mj_cloned_object(post_params);
						for( var i=0; i<tmp.length; ++i ) r0[tmp[i].name] = tmp[i].value;
						// and convert from key->value-object back to an array of (name,value)-objects ...
						return _mj_post_params_to_array(r0);
					}
					return tmp;
				}
				return _mj_post_params_to_array(post_params);
			},
			url: mj.webroot+opts.upload_url,
			multipart: _m_using_multipart_form_data,
			sequentialUploads: true,
			progressInterval: opts.progressInterval||250,
			bitrateInterval: 1000,
			forceIframeTransport: _m_use_iframe_transport,
			dropZone: null,
			add: function(e,data) {
				try {
					if( data.files.length > 0 ) {
						if( data.files.length>1 ) {
							showErrorToast('error: multiple file upload not yet supported here');
							data.files.splice(1,data.files.length-1);
						}
						data.process().done( function() {
							var file = data.files[0];
							if( file.size && file.size > mj.upload_limit ) {
								showErrorToast('error: file size exceeds allowed limit');
								_queue_completed_one(data,false);
							} else if( !_mj_file_allowed(file) ) {
								showErrorToast('error: invalid file type, allowed: '+opts.file_types_description+' ('+opts.file_types+')');
								_queue_completed_one(data,false);
							} else {
								if( opts.start ) opts.start( file );
								_upload_abort_fn = function() {
									if( data && data.hasOwnProperty('abort') && data.state()==='pending' ) data.abort();
								};
								data.submit();
							}
						} );
					}
				} catch( err ) {
					if( window.MVPageDebug ) window.MVPageDebug.dprint_err(err.message||err);
				}
			},
			change: function(e,data) {
				_queue_start( data, data.files.length );
			},
			progress: function(e,data) {
				$.each(data.files,function(idx,file) {
					var percent = Math.round(100*data.loaded/(1.0*data.total));
					if( opts.progress ) opts.progress(file,data.loaded,data.total,percent);
					// disable "cancel" button when 90% of file already uploaded
					if( data.loaded >= 0.9*data.total ) {
						fu_cancel.hide();
					}
				} );
			},
			done: function(e,data) {
				$.each(data.files,function(idx,file) {
					var j = data.result;
					if( j && j.error ) {
						if( !opts.hasOwnProperty('mute_error') || !opts.mute_error(file) ) showErrorToast( 'upload failed ('+j.error+'; '+j.info+'). please contact your administrator for help.' );
						if( opts.hasOwnProperty('fail') ) opts.fail(file);
					} else {
						opts.success(file,j);
					}
					opts.complete(file);
					_queue_completed_one(data,true);
				} );
			},
			fail: function(e,data) {
				$.each(data.files,function(idx,file) {
					if( data.textStatus==='abort' && data.errorThrown==='abort' ) {
						// aborted
						/***
						// BUT the file may already be uploaded completely ... and we do not know it now ...
						// TODO: determine if successful by additional request to server ..
						if( data.hasOwnProperty('loaded') && data.hasOwnProperty('total') && data.loaded===data.total ) {
							opts.success(file,j);
						}
						***/
						if( !opts.hasOwnProperty('mute_error') || !opts.mute_error(file,data) ) showErrorToast(mjt('mu-error-aborted'));
					} else {
						// other error
						if( !opts.hasOwnProperty('mute_error') || !opts.mute_error(file,data) ) showErrorToast(data.textStatus+' ('+data.errorThrown.toString()+')');
					}
					if( opts.hasOwnProperty('fail') ) opts.fail(file);
					opts.complete(file);
					_queue_completed_one(data,false);
				} );
			},
		} );
	}

	var widgets = {
		'single': {
			init: function( opts ) {
				_mj_init2html(this,opts,false);										// always html
			},
		},
		'multiple': {
			init: function( opts ) {
				_mj_init2html(this,opts,true);
			},
		},
	};

	function _call_widget_method( self, type, func, args ) {
		if( !widgets[type] ) throw new Error('Unknown mjUploadWidget type "'+type+'"');
		if( !widgets[type][func] ) throw new Error('mjUploadWidget type "'+type+'" has no function "'+func+'"');
		return widgets[type][func].apply( self, args );
	}

	mjRegisterSimpleJQueryPlugin($,'mjUploadWidget',{
		init: function(opts) {
			if( !opts.type ) throw new Error('No widget type specified');
			_mj_init_browser_support();
			var opts_defs = {
				file_types: mj.upload_image_file_types_filter,
				file_types_description: mjt('image-file-types'),
				button_width: 180,
				button_height: 18,
				button_text: mjt('custom-preview-upload-button'),
				progressInterval: 250,
				start: function(file) { },
				progress: function(file,bytesLoaded,bytesTotal,percent) { },
				success: function(file,json) { },
				complete: function(file) {
					return false;
				},
			};
			opts = Object.assign( {}, opts_defs, opts );
			if( !opts.hasOwnProperty('id') ) opts.id = _mj_fuw_id();
			$(this).data('mj-fuw',opts);
			_call_widget_method( this, opts.type, 'init', [opts] );
		},
		destroy: function() {
			// var opts = $(this).data('mj-fuw');
			// workaround for IE9... (<object> elements have no getAttribute() method)
			$(this).find('object').each( function() {
				if( this.getAttribute === null ) {
					this.getAttribute = function( name ) {
						return '';
					};
				}
			} );
			$(this).removeData(['mj-fuw']).empty();
		},
	});
})(jQuery,mj);
